import { render, staticRenderFns } from "./CategoryLevel3.vue?vue&type=template&id=34b68412&scoped=true&"
import script from "./CategoryLevel3.vue?vue&type=script&lang=js&"
export * from "./CategoryLevel3.vue?vue&type=script&lang=js&"
import style0 from "./CategoryLevel3.vue?vue&type=style&index=0&id=34b68412&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b68412",
  null
  
)

export default component.exports